module.exports = __webpack_public_path__ + "js/0.1dea4e0f.worker.js"